import { Button, Grid2, Typography } from "@mui/material"
import { PhoneInputFormField } from "../../shared/components/FormFields/PhoneInputFormField"
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { OrDivider } from "../../shared/utils/CustomDivider";
import { Link, useParams } from "react-router-dom";
import Layout from "./Layout";
import MainDialogBox from "../../shared/components/Dialog/DialogMainBox";
import { useMutation } from "@tanstack/react-query";
import { useDialog } from "../../shared/hook/useDialog";
import { useEffect, useRef, useState } from "react";
import { TextFormField } from "../../shared/components/FormFields/TextFormField";
import { useToaster } from "../../shared/utils/ToasterProvider";
import { isValidPhoneNumber } from "react-phone-number-input";
import useResponsive from "../../shared/utils/Responsive";
import SmLayout from "./SmLayout";
import api from "../../assets/nodeApi/axiosInstance";



const ConfirmMobile = () => {
    const { role } = useParams()
    const isSmallScreen = useResponsive("md")
    const { showToaster } = useToaster();
    const { open: open, handleClickOpen, handleClose } = useDialog();
    const [mobile, setMobile] = useState(null);
    const [isVerified, setIsVerified] = useState(false);
    const sendOtpMutation = useMutation({
        mutationFn: (formData) => api.post("send-password-reset-otp", formData),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const payload = {
            role: role,
            ...values
        }
        sendOtpMutation.mutate(payload, {
            onSuccess: () => {
                handleClickOpen()
                startCountdown();
            },
            onError: (error) => {
                showToaster('Error', error?.response?.data?.message, 'error')
            },
        });
    };
    const [countdown, setCountdown] = useState(0);
    const timerRef = useRef(null);
    const startCountdown = () => {
        setCountdown(300);
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        return () => clearInterval(timerRef.current);
    }, []);

    const verifyOtpMutation = useMutation({
        mutationFn: (formData) => api.post("verify-otp-and-send-link", formData),
    });

    const handleSubmitOtp = async (values, { setSubmitting, resetForm, setFieldError }) => {
        const obj = {
            mobile: mobile,
            otp: values.otp,
            role: role
        };
        verifyOtpMutation.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    setFieldError('otp', '')
                    handleClose();
                    setIsVerified(true);
                    resetForm();
                } else {
                    setFieldError('otp', response?.message || 'Invalid OTP');
                }
            },
            onError: (error) => {
                setFieldError('otp', error?.response?.data?.message || 'Invalid OTP');
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });
    };

    const reSendOtpMutation = useMutation({
        mutationFn: (formData) => api.post("resend-password-reset-otp", formData),
    });

    const handleResendOtp = () => {
        const payload = {
            mobile: mobile,
            role: role
        }
        reSendOtpMutation.mutate(payload, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    startCountdown();
                }
            },
            onError: () => {
                showToaster('Error', "Something Went wrong", 'error')
            },
        });
    }

    const ComfirmMobileForm = () => (
        <>

            {isVerified && <Typography variant='body2' color={"success.main"}>Your mobile number has been verified successfully. Please check your WhatsApp — we have sent you a reset password link.</Typography>}
            {!isVerified && <Formik
                initialValues={{ mobile: "" }}
                validationSchema={yup.object().shape({
                    mobile: yup
                        .string()
                        .required("Mobile Number is required")
                        .test("valid-phone", "Phone number is not valid", value =>
                            value && isValidPhoneNumber(value, "IN")
                        )
                })}
                onSubmit={handleSubmit}  >
                {({ setFieldValue }) => (
                    <Form>
                        <Grid2 container spacing={3}>

                            <Grid2 children size={{ xs: 12, sm: 6, md: 12 }}>
                                <Field
                                    name="mobile"
                                    component={PhoneInputFormField}
                                    label="Registered Mobile Number"
                                    isRequired={true}
                                    onChange={async (e) => {
                                        const value = e || "";
                                        await setFieldValue("mobile", value);
                                        setMobile(value);

                                    }}
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <Button variant='contained' fullWidth type="submit">Get Otp</Button>
                            </Grid2>
                            <Grid2 children size={12}>
                                <OrDivider text={"Or"} />
                            </Grid2>
                            <Grid2 children size={12} display={"flex"} justifyContent={"center"}>
                                <Typography variant='body2' fontSize={"12px"}>Remember it ?? </Typography>  <Link to={"/SelectLoginPath"}><Typography variant='body2' fontSize={"12px"} color='red.main'>Log In</Typography></Link>
                            </Grid2>

                        </Grid2>
                    </Form>
                )}
            </Formik>}
        </>
    )
    return (
        <>

            {
                !isSmallScreen && <Layout
                    title={"Forgot Password"}
                    text={"Enter your registered mobile number and we’ll share you the OTP to the registered mobile number"}
                >
                    {ComfirmMobileForm()}

                </Layout>
            }


            {
                isSmallScreen && <SmLayout
                    title={"Forgot Password"}
                    text={"Enter your registered mobile number and we’ll share you the OTP to the registered mobile number"}
                >
                    {ComfirmMobileForm()}

                </SmLayout>
            }


            <MainDialogBox open={open} handleClose={handleClose} width={"40%"} heading={"Verify OTP"}>
                <Formik initialValues={{ otp: "" }}
                    validationSchema={yup.object().shape({
                        otp: yup.string().required("OTP is required"),
                    })}
                    onSubmit={handleSubmitOtp}
                >
                    {() => (
                        <Form>
                            <Grid2 container spacing={"30px"}>
                                <Grid2 children size={{ xs: 12, sm: 12 }}>
                                    <Field
                                        name="otp"
                                        component={TextFormField}
                                        label="Enter OTP"
                                        isRequired={true}
                                    />
                                    {countdown > 0 && (
                                        <Typography variant="body2" color="red.main" sx={{ mt: 1 }}>
                                            Time remaining: {Math.floor(countdown / 60)
                                                .toString()
                                                .padStart(2, '0')}:{(countdown % 60).toString().padStart(2, '0')}
                                        </Typography>
                                    )}
                                </Grid2>
                                <Typography
                                    onClick={handleResendOtp}
                                    sx={{ cursor: 'pointer', color: 'red.main' }}
                                >
                                    Resend OTP
                                </Typography>
                                <Grid2 children size={{ xs: 12, sm: 12 }}>
                                    <Button variant='contained' fullWidth type="submit">Verify</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>




            </MainDialogBox>
        </>



    )
}

export default ConfirmMobile